import Token from './token'
import Form from './form'

export default {
  svg: 'mail',
  label: 'Send Email',
  type: 'communication',
  action: 'email',
  form: Form,
  token: Token
}
